// extracted by mini-css-extract-plugin
export default {"resultField":"ResultField_resultField__r755Z","textWrapper":"ResultField_textWrapper__cWNCH","text":"ResultField_text__PrbcX","copied":"ResultField_copied__wvO4F"};